<template>
    <el-button type="primary" @click="handleClick" :disabled="disabled">更新{{ disabled ?
        times : null }}</el-button>
</template>
<script>
import _ from 'lodash'
export default {
    name: 'Countdown',
    data() {
        return {
            disabled: false,
            times: 120,
        }
    },
    methods: {
        handleClick() {
            this.disabled = true
            this.$emit('click')
            this.countdown()
            setTimeout(() => {
                this.disabled = false
                this.times = 120; // 设置倒计时为5秒
            }, 120 * 1000)
        },
        countdown() {
            // 每秒更新倒计时
            let countdownInterval = ''
            if (countdownInterval) clearInterval(countdownInterval);
            countdownInterval = setInterval(() => {
                this.times--;
                if (this.times <= 0) {
                    clearInterval(countdownInterval);
                }
            }, 1000);
        },
    }
}
</script>